import ProvidersSlide from "../../../components/providers-slide";
import GameInfo from "../info";
import {useEffect, useState} from "react";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useSelector} from "react-redux";
import associateServices from "../../../services";
import store from "../../../reducers/createReducers";
import GLOBAL_ACTIONS from "../../../actions/global-actions";
import NewGames from "../../../components/new-games";
import '../index.css'
import PlayGameMobileFrame from "./frame-mobile";
import Loading from "../../../components/loading";
import PlayGameWebFrameError from "../web/frame-web-error";
import {useTranslation} from "react-i18next";
import stringHelper from "../../../helpers/string-helper";
import {toast} from "react-toastify";
import InformationToast from "../../../components/toast/InformationToast";

const PlayGameMobile = () => {
    const {t, i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language

    let {slug} = useParams()
    const navigate = useNavigate()
    const {authenticated} = useSelector(state => state.authenticationReducer)

    const {gameSelectedCurrency, activeLanguage} = useSelector(state => state.globalReducer)


    const [loading, setLoading] = useState(true)
    const [currencies, setCurrencies] = useState([])
    const [game, setGame] = useState(null)
    const [searchParams, setSearchParams] = useSearchParams()
    const [fullScreen, setFullScreen] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {

        setLoading(true)
        setGame(null)
        associateServices.playGame({slug, language: activeLanguage?.key}).then(res => {

            if (res?.status !== 200) {
                toast(<InformationToast
                    icon={'ti-x'}
                    title={t(`general.information`)}
                    message={t(`api-notifications.${res?.errors}`)}
                />)

                return setError(res?.errors || '')
            }

            setGame(res?.data?.game)
            if ((res?.data?.game?.is_live || !res?.data?.game?.has_demo)) {
                if (!authenticated) {
                    navigate(stringHelper.getModalPath('register', searchParams))
                } else {
                    setConf(res?.data?.game, res?.data?.favorited)
                }
            } else {
                setConf(res?.data?.game, res?.data?.favorited)
            }

        })

        return () => store.dispatch(GLOBAL_ACTIONS.setInPlayAction(false))
    }, [slug, authenticated, activeLanguage?.key])


    const setConf = (game, favorited) => {

        try {
            let webCurrencies = game?.currencies || game?.game_provider?.currencies


            try {
                if (game?.currencies)
                    webCurrencies = JSON.parse(game?.currencies)
            } catch (e) {
                console.error(e)
            }
            store.dispatch(GLOBAL_ACTIONS.setInPlayAction(true))

            if (gameSelectedCurrency) {

                if (webCurrencies?.length >= 1 && !webCurrencies?.includes(gameSelectedCurrency)) {
                    store.dispatch(GLOBAL_ACTIONS.setSelectedCurrency(webCurrencies[0]))
                }
            } else {
                if (webCurrencies?.length >= 1) {
                    store.dispatch(GLOBAL_ACTIONS.setSelectedCurrency(webCurrencies[0]))
                }
            }


            setCurrencies(webCurrencies)
            setLoading(false)

        } catch (e) {
            console.error(e)
        }
    }




    useEffect(() => {
        if (!gameSelectedCurrency && currencies?.length >= 1) {
            if (!currencies?.includes(gameSelectedCurrency)) {
                store.dispatch(GLOBAL_ACTIONS.setSelectedCurrency(currencies[0]))
            }
        }
    }, [gameSelectedCurrency, currencies])

    const handleSetGameType = (type) => {
        if (type === 'register' || type === 'login') {
            searchParams.set('modal', type);
            return setSearchParams(searchParams);
        }
        navigate(stringHelper.getLocalizedPath(currentLanguage, `/casino/games/${slug}/play?mode=${type}`))
    }


    return (
        <>
            <div className="section pt-0">
                <div className="container">
                    <div className="row">
                        <div className="col-12">


                            {
                                error ? <PlayGameWebFrameError error={t(`api-notifications.${error}`)}/> :
                                    loading ? <Loading/> :
                                        <PlayGameMobileFrame {...{
                                            handleSetGameType,
                                            currencies,
                                            game,
                                            setFullScreen,
                                            fullScreen
                                        }}/>

                            }

                        </div>

                        <GameInfo isMobile={true} game={game}/>
                    </div>
                </div>
            </div>

            <NewGames/>

            <ProvidersSlide/>

        </>

    )


}

export default PlayGameMobile
